import { useEffect } from "react";

/**
 * Runs an effect exactly once on mount, for syncing with external systems
 * (DOM APIs, third-party widgets, browser subscriptions).
 *
 * This is the ONLY sanctioned way to use useEffect in this codebase.
 * Do not use useEffect directly in components.
 */
export function useMountEffect(effect: () => void | (() => void)) {
  useEffect(effect, []);
}
